import axios from "axios";
import Qs from "qs";
import store from "@/store";
import storage from "store";
import { notification } from "ant-design-vue";
import { VueAxios } from "./axios";
import { USER_TOKEN, REFRESH_TOKEN } from "@/store/mutation-types";

// api基础URL路径
const api = {
  baseURL: process.env.VUE_APP_API_BASE_URL
};

// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  // baseURL: process.env.VUE_APP_API_BASE_URL,
  baseURL: api.baseURL,
  timeout: 90000 // 请求超时时间
});

// 异常拦截处理器
const errorHandler = error => {
  if (error.response) {
    const data = error.response.data;
    // 从 localstorage 获取 token
    const token = storage.get(USER_TOKEN);
    if (error.response.status === 403) {
      notification.error({
        message: "禁止访问",
        description: data.message
      });
    }
    if (
      error.response.status === 401 &&
      !(data.result && data.result.isLogin)
    ) {
      notification.error({
        message: "验证失败",
        description: "用户信息验证失败，请重新登录"
      });
      if (token) {
        store.dispatch("Logout").then(() => {
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        });
      }
    }
  }
  return Promise.reject(error);
};

// request interceptor
request.interceptors.request.use(config => {
  const token = storage.get(USER_TOKEN);
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  if (token) {
    config.headers["user_token"] = token;
  }
  return config;
}, errorHandler);

// response interceptor
request.interceptors.response.use(response => {
  if (response.data.resultCode === -1) {
    let data = {
      refresh_token: storage.get(REFRESH_TOKEN)
    };
    return (
      axios
        //.post(`/base/userlogin/refresh-token`, Qs.stringify(data))
        .post(
          // `${process.env.VUE_APP_API_BASE_URL}/userlogin/refresh-token`,
          `${api.baseURL}/userlogin/refresh-token`,
          Qs.stringify(data)
        )
        .then(res => {
          // console.log('res.data.resultCode', res.data.resultCode);
          if (res.data.resultCode === 1) {
            let token = res.data.result.user_token;
            storage.set(USER_TOKEN, token);
            response.config.headers["user_token"] = token;
            return axios.request(response.config).then(re => {
              return re.data;
            });
          } else {
            store.dispatch("Logout").then(() => {
              window.location.reload();
            });
          }
        })
    );
  }
  return response.data;
}, errorHandler);

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, request);
  }
};

export default request;
export { installer as VueAxios, request as axios, api };
